import { useCallback, useEffect, useState } from 'react';
import type { Manifest } from '@seemantham/core';
import { App } from './App';
import { Unlock } from './components/Unlock';
import { LockedError, loadManifest } from './lib/data';
import { useTheme } from './lib/useTheme';

type State =
  | { name: 'loading' }
  | { name: 'locked' }
  | { name: 'ready'; manifest: Manifest }
  | { name: 'empty' };

export function Root() {
  const [state, setState] = useState<State>({ name: 'loading' });
  useTheme(); // the lock screen follows the device theme too

  const load = useCallback(async () => {
    setState({ name: 'loading' });
    try {
      const manifest = await loadManifest();
      setState(manifest.items.length ? { name: 'ready', manifest } : { name: 'empty' });
    } catch (err) {
      setState(err instanceof LockedError ? { name: 'locked' } : { name: 'empty' });
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  if (state.name === 'locked') return <Unlock onUnlocked={load} />;
  if (state.name === 'ready') return <App manifest={state.manifest} />;
  if (state.name === 'empty') {
    return (
      <div className="unlock">
        <div className="unlock__panel">
          <h1 className="unlock__title">Seemantham</h1>
          <p className="unlock__sub">The photos are still being prepared. Try again shortly.</p>
        </div>
      </div>
    );
  }
  return (
    <div className="unlock">
      <div className="unlock__panel">
        <p className="unlock__sub">Opening</p>
      </div>
    </div>
  );
}
